import instance from "../../utils/instance";

class PostService {
    async getRoleOptions() {
        return await instance.post('/oa/common/CommonApi/GetZLSelectDict',{
            dictionaryName: "base_position",
            isFull: true,
            filter: "1=1"
        });
    }
}

export default new PostService();